var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_1713)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 1.66666C7.62049 1.66675 6.50738 1.93696 5.50354 2.45473C4.49971 2.97251 3.63424 3.72284 2.97936 4.64312C2.32448 5.5634 1.89917 6.62695 1.73892 7.74503C1.57867 8.86311 1.68812 10.0033 2.05815 11.0705C2.42817 12.1377 3.04804 13.1009 3.86603 13.8798C4.68402 14.6587 5.67642 15.2306 6.76043 15.548C7.84443 15.8653 8.98862 15.9189 10.0975 15.7041C11.2064 15.4893 12.2479 15.0125 13.135 14.3133L16.1783 17.3567C16.3355 17.5085 16.546 17.5925 16.7645 17.5906C16.983 17.5887 17.192 17.501 17.3465 17.3465C17.501 17.192 17.5887 16.983 17.5906 16.7645C17.5925 16.546 17.5085 16.3355 17.3567 16.1783L14.3133 13.135C15.1367 12.0905 15.6493 10.8353 15.7926 9.51309C15.9359 8.19087 15.704 6.85501 15.1235 5.6584C14.543 4.4618 13.6374 3.45279 12.5102 2.74685C11.3831 2.04091 10.08 1.66657 8.75 1.66666ZM3.33333 8.74999C3.33333 7.3134 3.90401 5.93565 4.91984 4.91983C5.93566 3.90401 7.31341 3.33332 8.75 3.33332C10.1866 3.33332 11.5643 3.90401 12.5802 4.91983C13.596 5.93565 14.1667 7.3134 14.1667 8.74999C14.1667 10.1866 13.596 11.5643 12.5802 12.5802C11.5643 13.596 10.1866 14.1667 8.75 14.1667C7.31341 14.1667 5.93566 13.596 4.91984 12.5802C3.90401 11.5643 3.33333 10.1866 3.33333 8.74999Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_1713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.be3d2445a0eef7be0fd38c1894c6d22d.svg";
export { ForwardRef as ReactComponent };